@if (!isLoading) {
  @if (ticket$ | async; as ticket) {
    <section class="ticket-detail pl-4 pt-4">
      <div class="basis-full">
        <div class="back-heading block md:hidden">
          <a class="back-link icon-text" [routerLink]="['/tickets']">
            <div class="custom-icon arrow_back"></div>
            Back to Tickets
          </a>
        </div>
        <div
          class="ticket-detail-content ticket-title-wrapper"
          #ticketDetailContent
        >
          <!-- Case Number, Title, Date Created/Closed -->
          <app-ticket-detail-header
            [ticket]="ticket"
            class="ticket-detail-header"
            #ticketDetailHeader
          ></app-ticket-detail-header>
        </div>

        <div class="scrolling-list" id="ticketDetailScroll">
          <div class="ticket-detail-content" #ticketDetailContent>
            <!-- Locaion & Service Info -->
            <app-ticket-detail-service
              [ticket]="ticket"
            ></app-ticket-detail-service>

            <div class="ticket-detail-section description-contact">
              <div class="bookends">
                <div class="icon-text section-title">
                  <div class="custom-icon ticket">ticket</div>
                  <span>Details</span>
                </div>

                <input
                  id="collapsible1"
                  class="toggle"
                  type="checkbox"
                  checked
                  [(ngModel)]="showDetails"
                />
                <ng-container>
                  <label
                    for="collapsible1"
                    class="lbl-toggle"
                    tabindex="0"
                    (click)="toggleDetailState()"
                  >
                    @if (showDetails) {
                      <span class="more icon-text"
                        >View Less
                        <div class="custom-icon arrow_collapse">
                          arrow_collapse
                        </div>
                      </span>
                    } @else {
                      <span class="less icon-text"
                        >View More
                        <div class="custom-icon arrow_expand">arrow_expand</div>
                      </span>
                    }
                  </label>
                </ng-container>
              </div>

              <!-- Description -->
              @if (ticket.Description || ticket.Contact) {
                <div
                  [@detailsAnimation]="detailState"
                  (@detailsAnimation.done)="animationDone()"
                >
                  @if (ticket.Description) {
                    <div class="description">
                      <div class="description-header">
                        <div class="label">Description of Issue</div>

                        <input
                          id="collapsible2"
                          class="toggle"
                          type="checkbox"
                          [(ngModel)]="showDescription"
                        />
                        <label
                          for="collapsible2"
                          class="lbl-toggle"
                          tabindex="0"
                          (click)="toggleDescriptionState()"
                        >
                          @if (showDescription) {
                            <span class="less description-icon-text"
                              >View Less
                              <div class="custom-icon arrow_collapse">
                                arrow_collapse
                              </div>
                            </span>
                          } @else {
                            <span class="more description-icon-text"
                              >View More
                              <div class="custom-icon arrow_expand">
                                arrow_expand
                              </div>
                            </span>
                          }
                        </label>
                      </div>

                      <div
                        class="container"
                        [@descriptionAnimation]="descriptionState"
                      >
                        <div #descriptionElement>
                          @for (
                            section of descriptionSections$ | async;
                            track section
                          ) {
                            <p [innerHTML]="section + '<br />'"></p>
                          }
                        </div>
                      </div>
                    </div>

                    <div class="description-divider"></div>
                  }

                  @if (isNocTicket) {
                    <app-ticket-iq-observation
                        [ticket]="ticket"
                      ></app-ticket-iq-observation>
                    <div class="description-divider"></div>
                  }

                  <!-- Primary Reporter -->
                  @if (ticket.Contact?.Name) {
                    <app-ticket-detail-contact
                      [ticket]="ticket"
                    ></app-ticket-detail-contact>
                  }
                </div>
              }
            </div>

            <!-- File Uploads -->
            <div class="ticket-detail-section">
              <div class="bookends">
                <div class="icon-text section-title">
                  <div class="custom-icon file-upload-icon">file upload</div>
                  <span>Files</span>
                </div>
              </div>
              <app-file-upload
                [ticket]="ticket"
                [allowUserInput]="allowUserInput$ | async"
                (filesUploaded)="fileUploaded($event)"
              ></app-file-upload>
            </div>

            <!-- Comments Header (for large screens only) -->
            <div class="ticket-detail-section slide-comment hidden md:block">
              <div class="bookends">
                <div class="icon-text section-title">
                  <div class="custom-icon comment">Comment</div>
                  <span
                    >Comments ({{
                      ticket.Comments__r ? ticket.Comments__r.totalSize : '0'
                    }})</span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- Comments -->
          @if ((browserSize$ | async) !== 'small') {
            <div [ngClass]="{ 'comments-collapsed': !showDetails }">
              <div class="comments-inner">
                <app-ticket-comment
                  [ticket]="ticket"
                  [viewMoreComments]="showDetails"
                  [widgetHeight]="widgetHeight"
                  [fileUploadResult]="fileUploadResult"
                  [descriptionContentHeight]="descriptionContentHeight"
                  (saved)="reloadTicketsData()"
                ></app-ticket-comment>
              </div>
            </div>
          } @else {
            <!-- Comments Header (for small or mobile screens only) -->
            <div class="ticket-detail-section">
              <div class="icon-text section-title comment-title">
                <span>View Comments</span>
                <div class="comment-total">
                  <div class="icon-text comment-count">
                    @if (hasUnreadComments(ticket.Comments__r?.records)) {
                      <div class="custom-icon comment_alert"></div>
                    } @else {
                      <div class="custom-icon comment_read"></div>
                    }
                  </div>
                  &nbsp;
                  {{ ticket.Comments__r ? ticket.Comments__r.totalSize : '0' }}
                  <div class="custom-icon arrow_progress">arrow_progress</div>
                </div>
                <a
                  [routerLink]="['/tickets', ticket.Id, 'comments']"
                  tabindex="-1"
                  class="ticket-link desktop"
                  ><div class="cta-link">desktop</div></a
                >
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  } @else {
    <section class="ticket-detail empty pl-4 pt-4">
      <div class="ticket-detail-header">
        <div class="number-type">
          <div class="number">
            <div class="label">Ticket #</div>
            - - -
          </div>
          <div class="type">
            <div class="label">Ticket Type</div>
            <div class="text">- - -</div>
          </div>
        </div>
        <div class="status-date">
          <div class="label">Status</div>
          - - -
        </div>
      </div>
      <div class="empty-description">
        <div class="text-2xl font-semibold">No tickets available</div>
        <div class="text-lg">
          You can create a new ticket at any time using the "Create Ticket"
          button.
        </div>
      </div>
    </section>
  }
}
